import CallDetails from 'records/CallDetails';

// Map the ridiculous format of call search results into
// something sane
export default function searchResultsToCallDetails(searchResult) {
  return new CallDetails({
    caller: searchResult.caller,
    callerId: searchResult.caller.userId,
    id: searchResult.id,
    numberOfCallerScorecardResults: searchResult.number_of_caller_scorecard_results,
    description: searchResult.custom_content.metadata_line_one,
    numberOfScorecardResults: searchResult.number_of_scorecard_results,
    numberOfVotesUp: searchResult.number_of_votes_up,
    numberOfVotesDown: searchResult.number_of_votes_down,
    datetime: searchResult.fields.Date,
    coachMe: searchResult.fields['Coaching Requested'],
    company: searchResult.fields.Company,
    contact: searchResult.fields.Contact,
    crmLink: searchResult.fields['CRM Link'],
    durationSeconds: searchResult.fields.Duration,
    callStage: searchResult.fields['Call Stage'],
    // Doesnt exist i dont think
    outcome: searchResult.fields.Outcome,
    title: searchResult.fields.Title,
    vote: searchResult.vote ?? searchResult.callDetails?.vote,
    state: searchResult.state,

    // original search result model for any legacy code that relies on it
    searchResult,

    // Deprecated.  Don't use.  Use datetime instead
    timestamp: searchResult.fields.Date,

    // TODO legacy property for CallCardScore.  Don't reuse
    loading: false,
  });
}
